export const sliderItems = [
  {
    id: 1,
    img: process.env.PUBLIC_URL + '/img/slide1.png',
    title: "SPECIAL SALE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS...",
    bg: "f5fafd",
  },
  {
    id: 2,
    img: process.env.PUBLIC_URL + '/img/slide2.png',
    title: "INSPIRATION",
    desc: "SHOP SPONTANEOUS TREATS OR THE PERFECT PRESENT FOR VERY SPECIAL OCCASIONS...",
    bg: "fcf1ed",
  },
  {
    id: 3,
    img: process.env.PUBLIC_URL + '/img/slide6.png',
    title: "LOUNGEWEAR LOVE",
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS...",
    bg: "fbf0f4",
  },
];

export const categories = [
  {
    id: 1,
    img: process.env.PUBLIC_URL + '/img/product4.jpg',
    title: "SHIRT STYLE!",
  },
  {
    id: 2,
    img: process.env.PUBLIC_URL + '/img/product3.jpg',
    title: "LOUNGEWEAR LOVE",
  },
  {
    id: 3,
    img: process.env.PUBLIC_URL + '/img/product1.jpg',
    title: "LIGHT JACKETS",
  },
];

export const popularProducts = [
  {
    id:1,
    img: process.env.PUBLIC_URL + '/img/shirt.png',
  },
  {
    id:2,
    img: process.env.PUBLIC_URL + '/img/lady1.png',
  },
  {
    id:3,
    img:process.env.PUBLIC_URL + '/img/sneakers.png',
  },
  {
    id:4,
    img:process.env.PUBLIC_URL + '/img/lady2.png',
  },
  {
    id:5,
    img: process.env.PUBLIC_URL + '/img/shirt2.png',
  },
  {
    id:6,
    img:process.env.PUBLIC_URL + '/img/lady3.png',
  },
  {
    id:7,
    img:process.env.PUBLIC_URL + '/img/cap.png',
  },
  {
    id:8,
    img:process.env.PUBLIC_URL + '/img/suit.png',
  },
]